module.exports = __webpack_public_path__ + "img/jan-month.ada33557.png";